import {useState} from 'react';
import {IMAGES, SVG} from '../../../../../../../constants/assetLists';
import {NetworkDetailsFormValues, NetworkNodeFieldPath} from '../../../types';
import OnboardingValidationBadge from '../../OnboardingValidationBadge';
import { get } from 'react-hook-form';
import { useFormContext} from 'react-hook-form';
type Props = {
  selectedFieldPath: NetworkNodeFieldPath;
};

const ZONES = [
  {
    name: 'שם אזור',
    desc: 'כתבו את שם האזור שהיום בשימוש',
  },
  {
    name: 'שם מקוצר',
    desc: 'מצאו קיצור לשם אשר יהיה מזוהה',
  },
  {
    name: 'דוגמא',
    desc: 'שם אזור: מרפסת חיצונית, שם מקוצר: מ”ח, או מ.חוץ. השם יוצג בהודעות: מרפסת חיצונית (מ.חוץ) וביומן יוצג מ”ח.',
  },
];

function ZonesHeader({selectedFieldPath}: Props) {
  const [showZonesDetails, setShowZonesDetails] = useState(true);

  const toggleZonesDetails = (opt: boolean) => {
    setShowZonesDetails(opt);
  };
  const {watch, formState: { errors }} = useFormContext<NetworkDetailsFormValues>();
  const zones = watch(`${selectedFieldPath}.zones`) ?? [];
  const zoneError = get(
    errors,
    `${selectedFieldPath}.zones`
  );

const showZoneValidation =
  zones.length === 0 ||
  !!zoneError;
  return (
    <div className="pb-2">
      <div className="flex flex-col">
        <div className="flex items-center gap-3">
            <p className="m-0 text-xl text-deepAqua font-bold">הגדרת אזורים</p>
            <OnboardingValidationBadge show={showZoneValidation}  />
          </div>
        <p className="m-0 mt-2 text-base text-darkerGray">
          הגדירו את האזורים הקיימים במסעדה וצרפו להם צבע. השולחנות המוזמנים
          יוצגו בצבע ביומן ובבריף היומי.
        </p>
        <p className="m-0 text-base text-darkerGray">
          השם המלא והמקוצר יוצגו בהודעות, ביומן ובבריף היומי יוצג השם המקוצר.
        </p>
      </div>

      <div className="mt-1 flex flex-col gap-2.5">
        <div className="flex justify-end">
          <button
            className="py-1 px-2 bg-icyBlue rounded-md flex items-center gap-2"
            onClick={() => toggleZonesDetails(true)}>
            <img
              src={SVG.infoBlueIcon}
              alt="info"
              className="w-5 h-5 object-contain"
            />
            <p className="m-0 text-base text-tealBlue underline">
              הסבר ודוגמאות לשם אזור ושם מקוצר
            </p>
          </button>
        </div>

        {showZonesDetails && (
          <div className="px-4 py-1 border border-[#E9FAFF] bg-[#F0FCFF] rounded-tr-md rounded-br-md rounded-bl-md shadow-md relative">
            <div className="flex gap-16">
              <div className="flex flex-col gap-2 w-[638px]">
                <p className="m-0 text-base text-black">
                  כדאי לבחור שמות ברורים, כאלה שקיימים היום במסעדה ומזוהים
                  לכולם.
                </p>

                {ZONES.map((zone, idx) => (
                  <div
                    key={idx}
                    className={`py-1 flex items-center gap-2 border-b border-gray70 ${idx === ZONES.length - 1 ? 'border-b-0' : ''}`}>
                    <div className="w-[122px]">
                      <p className="m-0 text-base font-bold text-darkBlue">
                        {zone.name}
                      </p>
                    </div>

                    <p className="m-0 text-base text-black">{zone.desc}</p>
                  </div>
                ))}
              </div>

              <div className="flex flex-col gap-1">
                <p className="m-0 text-base text-black">יומן</p>

                <div className="w-[194px] h-[138px]">
                  <img
                    src={IMAGES.calendarScreen}
                    alt="יומן"
                    className="w-full h-full object-contain"
                  />
                </div>
              </div>

              <div className="flex flex-col gap-1">
                <p className="m-0 text-base text-black">בריף יומי</p>

                <div className="w-[301px] h-[133px]">
                  <img
                    src={IMAGES.briefScreen}
                    alt="בריף יומי"
                    className="w-full h-full object-contain"
                  />
                </div>
              </div>
            </div>
            <button
              className="absolute top-1 left-2 w-6 h-6 flex justify-center items-center pr-3"
              onClick={() => toggleZonesDetails(false)}>
              <img
                src={SVG.closeDarkIcon}
                className="w-[11px] h-[11px] object-contain"
              />
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default ZonesHeader;
